import PublishCampaign from '@/Component/Brand/MyCampaigns/CreateCampaign/PublishCampaign'

const PublishedCampaignPage = () => {
  return (
    <PublishCampaign />
  )
}

export default PublishedCampaignPage
